/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione la presa in carico degli apparati
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsPresaInCaricoSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoSrvc.js
// module id = 16
// module chunks = 0